(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const select = root.querySelector('[data-stone-select]');
    const form = root.querySelector('[data-stone-form]');
    const message = root.querySelector('[data-stone-message]');
    const quantityInput = form.elements.quantity;
    const quantityMinus = root.querySelector('[data-quantity-minus]');
    const updateMobileTotal = () => {
      const option = select.selectedOptions[0];
      const count = Math.max(1, Math.floor(Number(quantityInput.value) || 1));
      root.querySelector('[data-stone-mobile-quantity]').textContent = String(count);
      root.querySelector('[data-stone-mobile-name]').textContent = option.dataset.words || option.dataset.name;
      const display = root.querySelector('[data-stone-mobile-price]');
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: display.dataset.currency || 'USD'
      }).format(cents * count / 100);
      root.querySelector('[data-stone-mobile-current]').textContent = option.dataset.priceCents ? money(Number(option.dataset.priceCents)) : option.dataset.price;
      const compare = root.querySelector('[data-stone-mobile-compare]');
      compare.hidden = !(Number(option.dataset.compareCents) > Number(option.dataset.priceCents));
      compare.textContent = compare.hidden ? '' : money(Number(option.dataset.compareCents));
    };
    const setQuantity = value => {
      quantityInput.value = String(Math.max(1, Math.floor(Number(value) || 1)));
      quantityMinus.disabled = Number(quantityInput.value) <= 1;
      updateMobileTotal();
    };
    quantityInput.addEventListener('change', () => setQuantity(quantityInput.value));
    quantityMinus.addEventListener('click', () => setQuantity(Number(quantityInput.value) - 1));
    root.querySelector('[data-quantity-plus]').addEventListener('click', () => setQuantity(Number(quantityInput.value) + 1));
    let adding = false;
    const preview = root.dataset.preview === 'true';
    const parameter = preview ? 'stone' : 'variant';
    const requested = new URL(location.href).searchParams.get(parameter);
    if ([...select.options].some(option => option.value === requested)) select.value = requested;
    const update = (writeUrl = false) => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const image = root.querySelector('[data-stone-image]');
      if (!root.dataset.experienceReady) image.src = option.dataset.image;
      image.alt = [option.dataset.name, option.dataset.words].filter(Boolean).join(' — ');
      const energy = root.querySelector('[data-stone-energy]');
      const terms = (option.dataset.energy || '').split('·').map(term => term.trim()).filter(Boolean);
      energy.replaceChildren(...terms.map(term => {
        const pill = document.createElement('span');
        pill.className = 'product-gallery__energy-pill';
        pill.textContent = term;
        return pill;
      }));
      energy.setAttribute('aria-label', terms.join(' · '));
      energy.hidden = terms.length === 0;
      root.querySelector('[data-stone-name]').textContent = option.dataset.name;
      root.querySelector('[data-stone-words]').textContent = option.dataset.words;
      root.querySelector('[data-stone-price]').textContent = option.dataset.price;
      const compare = root.querySelector('[data-stone-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      const buy = root.querySelector('[data-stone-buy]');
      buy.disabled = adding || preview || option.dataset.available !== 'true';
      root.querySelector('[data-stone-purchase]').disabled = buy.disabled;
      const mobileBuy = root.querySelector('[data-stone-mobile-buy]');
      mobileBuy.disabled = buy.disabled;
      root.querySelector('[data-stone-mobile-name]').textContent = option.dataset.name;
      updateMobileTotal();
      mobileBuy.textContent = adding ? 'Adding...' : 'Add to Cart';
      buy.textContent = adding ? 'Adding...' : preview ? 'Add to Cart' : buy.disabled ? 'Sold out' : 'Add to Cart';
      root.querySelectorAll('[data-stone-thumb]').forEach(thumb => {
        const active = thumb.dataset.stoneThumb === select.value;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      if (writeUrl) {
        const url = new URL(location.href);
        url.searchParams.set(parameter, select.value);
        history.replaceState(null, '', url);
      }
    };
    select.addEventListener('change', () => update(true));
    root.querySelectorAll('[data-stone-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
      select.value = thumb.dataset.stoneThumb;
      update(true);
    }));
    root.querySelector('[data-stone-purchase]').addEventListener('click', () => {
      if (adding || preview || select.selectedOptions[0]?.dataset.available !== 'true' || !form.reportValidity()) return;
      const quantity = Number(form.elements.quantity.value);
      window.location.assign(`${root.querySelector('[data-stone-purchase]').dataset.cartUrl}/${select.value}:${quantity}`);
    });
    root.querySelector('[data-stone-mobile-buy]').addEventListener('click', () => form.requestSubmit());
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding || preview || select.selectedOptions[0]?.dataset.available !== 'true') return;
      adding = true;
      message.textContent = '';
      update();
      try {
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: {Accept: 'application/json'},
          body: new FormData(form)
        });
        const result = await response.json().catch(() => {
          throw new Error('Unable to add this stone. Please try again.');
        });
        if (!response.ok) throw new Error(result.description || 'Unable to add this stone. Please try again.');
        window.location.assign(form.dataset.cartUrl);
      } catch (error) {
        message.textContent = error.message || 'Unable to add this stone. Please try again.';
        adding = false;
        update();
      }
    });
    update();
  }
  document.addEventListener('DOMContentLoaded', () => init(document.querySelector('[data-single-stone]')));
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-single-stone]')));
})();
